module.exports = __webpack_public_path__ + "img/9791195044641.698a17c4.jpg";